import React, { useEffect, useState } from "react";
import ExpenseStatementTable from "./ExpenseStatementTable/ExpenseStatementTable";
import { getExpenseDeviation } from "../../utils/ActionCreator";
import SpinnerLoader from '../../../../../../../presentationals/Loader/Loader.component';
// import SpinnerLoader from "../../../../../Common/Loader.component";
import moment from "moment";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  BarChart,
  Bar,
  Cell,
} from "recharts";
import { Pencil } from "lucide-react";
import ExpenseLineChart from "./ExpenseLineChart";
import ExpenseBarChart from "./ExpenseBarChart";
import ExpenseForecastChart from "./ExpenseForecastChart";
import ProgressGraph from "./ProgressBar";

function ExpenseStatemement({
  filterFromDate,
  filterToDate,
  filterApply,
  setFilterApply,
  chartData,
}) {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");

  const fetchDeviationData = (date) => {
    // If no date provided, fetch current month data (reset case)
    if (!date) {
      console.log("No filter date provided, fetching current month data");
      date = moment().format("DD-MM-YYYY");
    }

    const parsedDate = moment(date, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
    if (!parsedDate.isValid()) {
      console.error("Invalid date:", date);
      return;
    }

    const formattedMonth = parsedDate.format("MMM YYYY");
    console.log("Fetching deviation for:", formattedMonth);
    setLoading(true);

    getExpenseDeviation(
      formattedMonth,
      (callback) => {
        setLoading(false);

        const data =
          callback && callback.status === 200
            ? callback.data
            : Array.isArray(callback)
              ? callback
              : null;

        console.log("Deviation response:", data);

        if (Array.isArray(data)) {
          setTableData(data);
          setSelectedMonth(formattedMonth);
        } else {
          setTableData([]);
        }
      },
      (error) => {
        setLoading(false);
        console.error("Deviation error:", error);
        setTableData([]);
      },
    );
  };

  // On mount — use filterFromDate or current month
  useEffect(() => {
    const date = filterFromDate || moment().format("DD-MM-YYYY");
    fetchDeviationData(date);
  }, []);

  // Re-fetch when filter changes
  useEffect(() => {
    fetchDeviationData(filterFromDate); // Now handles null case
  }, [filterFromDate]);

  // Listen for expense data refresh events
  useEffect(() => {
    const handleRefreshExpenseData = () => {
      console.log("🔄 Refreshing expense data after add/update");
      fetchDeviationData(filterFromDate);
    };

    window.addEventListener("refreshExpenseData", handleRefreshExpenseData);

    return () => {
      window.removeEventListener(
        "refreshExpenseData",
        handleRefreshExpenseData,
      );
    };
  }, [filterFromDate]);

  return (
    <>
      {loading && <SpinnerLoader />}
      {/* 3 tabs  */}
      {!loading && tableData.length === 0 && (
        <div
          style={{
            padding: "40px",
            textAlign: "center",
            color: "#666",
            backgroundColor: "#f8f9fa",
            margin: "20px",
            borderRadius: "8px",
          }}
        >
          <div
            style={{ fontSize: "16px", fontWeight: "600", marginBottom: "8px" }}
          >
            No data available for the selected period
          </div>
          <div style={{ fontSize: "14px", color: "#999" }}>
            Try selecting a different date range or check if data exists for the
            selected month.
          </div>
        </div>
      )}
      {!loading && tableData.length > 0 && (
        <div style={{ marginTop: "4rem" }}>
          <ExpenseStatementTable data={tableData} month={selectedMonth} />
        </div>
      )}
      {/* <div className="container-fluid">
        <div className="row">
          <div className="col-sm-6 col-xs-12" style={{ margin: "10px 0" }}>
            <ExpenseLineChart />
          </div>
          <div className="col-sm-6 col-xs-12" style={{ margin: "10px 0" }}>
            <ExpenseBarChart />
          </div>
        </div>
        <div style={{ marginBottom: "60px" }}>
          <ExpenseForecastChart />
        </div>
        <div>
          <ProgressGraph data={chartData} />
        </div>
      </div> */}
    </>
  );
}

export default ExpenseStatemement;

const Linechart = () => {
  const initialData = [
    { month: "Jan", expense: 4000 },
    { month: "Feb", expense: 3000 },
    { month: "Mar", expense: 5000 },
    { month: "Apr", expense: 2780 },
    { month: "May", expense: 1890 },
    { month: "Jun", expense: 2390 },
    { month: "Jul", expense: 3490 },
  ];
  const [chartData, setChartData] = useState(initialData);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleEdit = (month, newValue) => {
    setChartData((prev) =>
      prev.map((d) => (d.month === month ? { ...d, expense: newValue } : d)),
    );
  };

  const handleChartMouseMove = (state) => {
    if (state && state.activeTooltipIndex !== undefined) {
      setActiveIndex(state.activeTooltipIndex);
    }
  };

  const CustomTooltip = ({ active, payload, onEdit }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editValue, setEditValue] = useState("");

    if (!active || !payload || !payload.length) return null;

    const { month, expense } = payload[0].payload;

    const handleEditClick = () => {
      setEditValue(expense.toString());
      setIsEditing(true);
    };

    const handleSave = () => {
      if (editValue && !isNaN(editValue)) {
        onEdit(month, parseFloat(editValue));
      }
      setIsEditing(false);
    };

    const handleCancel = () => {
      setIsEditing(false);
      setEditValue("");
    };

    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #e2e8f0",
          borderRadius: "10px",
          padding: "12px 14px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
          minWidth: "170px",
          pointerEvents: "auto",
        }}
      >
        {!isEditing ? (
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div>
              <div
                style={{
                  fontSize: "11px",
                  color: "#94a3b8",
                  fontWeight: 600,
                  marginBottom: 2,
                }}
              >
                {month}
              </div>
              <div
                style={{ fontSize: "15px", color: "#1e293b", fontWeight: 700 }}
              >
                ${expense.toLocaleString()}
              </div>
            </div>
            <button
              onClick={handleEditClick}
              style={{
                marginLeft: "auto",
                padding: "6px 8px",
                backgroundColor: "#015c57",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "11px",
                fontWeight: 700,
                color: "#fff",
                letterSpacing: "0.3px",
              }}
            >
              <Pencil size={14} />
            </button>
          </div>
        ) : (
          <div>
            <div
              style={{
                fontSize: "11px",
                color: "#94a3b8",
                fontWeight: 600,
                marginBottom: 8,
              }}
            >
              {month} — Edit Expense
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span
                style={{ fontSize: "13px", color: "#64748b", fontWeight: 600 }}
              >
                $
              </span>
              <input
                type="number"
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSave();
                  if (e.key === "Escape") handleCancel();
                }}
                autoFocus
                style={{
                  width: "85px",
                  padding: "6px 8px",
                  border: "1.5px solid #015c57",
                  borderRadius: "6px",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#1e293b",
                  outline: "none",
                }}
              />
              <button
                onClick={handleSave}
                style={{
                  padding: "6px 10px",
                  backgroundColor: "#015c57",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 700,
                  color: "#fff",
                }}
              >
                ✓
              </button>
              <button
                onClick={handleCancel}
                style={{
                  padding: "6px 10px",
                  backgroundColor: "#f1f5f9",
                  border: "1px solid #e2e8f0",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 700,
                  color: "#64748b",
                }}
              >
                ✕
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          border: "1px solid #E5E7EB",
          padding: "24px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <ResponsiveContainer width="100%" height={350}>
          <LineChart
            data={chartData}
            margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
            onMouseMove={handleChartMouseMove}
            onMouseLeave={() => setActiveIndex(null)}
          >
            <CartesianGrid
              strokeDasharray=""
              stroke="#E5E7EB"
              vertical={false}
              horizontal={false}
            />
            <XAxis
              dataKey="month"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#6B7280", fontSize: 12, fontWeight: 500 }}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#6B7280", fontSize: 12, fontWeight: 500 }}
              // tickFormatter={(v) => ⁠ $${v.toLocaleString()} ⁠}
            />
            <Line
              type="monotone"
              dataKey="expense"
            //   radius={[6, 6, 0, 0]}
            //   onMouseEnter={(_, index) => setActiveIndex(index)}
            // >
            //   {chartData.map((_, index) => (
            //     <Cell
            //       key={index}
            //       fill={activeIndex === index ? "#013d39" : "#015c57"}
            //       opacity={
            //         activeIndex === null || activeIndex === index ? 1 : 0.5
            //       }
            //     />
            //   ))}
            // </Bar>
            stroke="#015c57"
              strokeWidth={3}
              dot={{
                fill: "#015c57",
                r: 6,
                strokeWidth: 2,
                stroke: "#fff",
                cursor: "pointer",
              }}
              activeDot={{ r: 8, fill: "#013d39" }}
              isAnimationActive={true}
            />


            
  
            {/* Custom tooltip using Recharts' built-in tooltip position system */}
            {activeIndex !== null && (
              <foreignObject
                x={
                  activeIndex >= chartData.length - 2
                    ? (activeIndex - 1.5) * (100 / chartData.length) + "%"
                    : (activeIndex + 0.5) * (100 / chartData.length) + "%"
                }
                y={20}
                width={220}
                height={150}
                style={{ overflow: "visible", pointerEvents: "auto" }}
              >
                <CustomTooltip
                  active={true}
                  payload={[{ payload: chartData[activeIndex] }]}
                  onEdit={handleEdit}
                />
              </foreignObject>
            )}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

const Barchart = () => {
  const initialData = [
    { month: "Jan", expense: 4000 },
    { month: "Feb", expense: 3000 },
    { month: "Mar", expense: 5000 },
    { month: "Apr", expense: 2000 },
    { month: "May", expense: 5000 },
    { month: "June", expense: 2000 },
    { month: "July", expense: 5000 },
    { month: "Aug", expense: 2000 },
  ];
  const [chartData, setChartData] = useState(initialData);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleEdit = (month, newValue) => {
    setChartData((prev) =>
      prev.map((d) => (d.month === month ? { ...d, expense: newValue } : d)),
    );
  };

  const CustomTooltip = ({ active, payload, coordinate, onEdit }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editValue, setEditValue] = useState("");

    if (!active || !payload || !payload.length) return null;

    const { month, expense } = payload[0].payload;

    const handleEditClick = () => {
      setEditValue(expense.toString());
      setIsEditing(true);
    };

    const handleSave = () => {
      if (editValue && !isNaN(editValue)) {
        onEdit(month, parseFloat(editValue));
      }
      setIsEditing(false);
    };

    const handleCancel = () => {
      setIsEditing(false);
      setEditValue("");
    };

    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #e2e8f0",
          borderRadius: "10px",
          padding: "12px 14px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
          minWidth: "170px",
          pointerEvents: "auto",
        }}
      >
        {!isEditing ? (
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div>
              <div
                style={{
                  fontSize: "11px",
                  color: "#94a3b8",
                  fontWeight: 600,
                  marginBottom: 2,
                }}
              >
                {month}
              </div>
              <div
                style={{ fontSize: "15px", color: "#1e293b", fontWeight: 700 }}
              >
                ${expense.toLocaleString()}
              </div>
            </div>
            <button
              onClick={handleEditClick}
              style={{
                marginLeft: "auto",
                padding: "6px 8px",
                backgroundColor: "#015c57",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "11px",
                fontWeight: 700,
                color: "#fff",
                letterSpacing: "0.3px",
              }}
            >
              <Pencil size={14} />
            </button>
          </div>
        ) : (
          <div>
            <div
              style={{
                fontSize: "11px",
                color: "#94a3b8",
                fontWeight: 600,
                marginBottom: 8,
              }}
            >
              {month} — Edit Expense
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span
                style={{ fontSize: "13px", color: "#64748b", fontWeight: 600 }}
              >
                $
              </span>
              <input
                type="number"
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSave();
                  if (e.key === "Escape") handleCancel();
                }}
                autoFocus
                style={{
                  width: "85px",
                  padding: "6px 8px",
                  border: "1.5px solid #015c57",
                  borderRadius: "6px",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#1e293b",
                  outline: "none",
                }}
              />
              <button
                onClick={handleSave}
                style={{
                  padding: "6px 10px",
                  backgroundColor: "#015c57",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 700,
                  color: "#fff",
                }}
              >
                ✓
              </button>
              <button
                onClick={handleCancel}
                style={{
                  padding: "6px 10px",
                  backgroundColor: "#f1f5f9",
                  border: "1px solid #e2e8f0",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 700,
                  color: "#64748b",
                }}
              >
                ✕
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        border: "1px solid #E5E7EB",
        padding: "24px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <ResponsiveContainer width="100%" height={350}>
        <BarChart
          data={chartData}
          margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
          onMouseLeave={() => setActiveIndex(null)}
        >
          <CartesianGrid
            strokeDasharray=""
            stroke="#E5E7EB"
            vertical={false}
            horizontal={false}
          />
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#6B7280", fontSize: 12, fontWeight: 500 }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#6B7280", fontSize: 12, fontWeight: 500 }}
            //   tickFormatter={(v) => ⁠ $${v.toLocaleString()} ⁠}
          />
          <Bar
            dataKey="expense"
            radius={[6, 6, 0, 0]}
            onMouseEnter={(_, index) => setActiveIndex(index)}
          >
            {chartData.map((_, index) => (
              <Cell
                key={index}
                fill={activeIndex === index ? "#013d39" : "#015c57"}
                opacity={
                  activeIndex === null || activeIndex === index ? 1 : 0.5
                }
              />
            ))}
          </Bar>

          {/* Custom tooltip using Recharts' built-in tooltip position system */}
          {activeIndex !== null && (
            <foreignObject
              x={
                activeIndex >= chartData.length - 2
                  ? (activeIndex - 1.5) * (100 / chartData.length) + "%"
                  : (activeIndex + 0.5) * (100 / chartData.length) + "%"
              }
              y={20}
              width={220}
              height={150}
              style={{ overflow: "visible", pointerEvents: "auto" }}
            >
              <CustomTooltip
                active={true}
                payload={[{ payload: chartData[activeIndex] }]}
                onEdit={handleEdit}
              />
            </foreignObject>
          )}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
